import { Container, Size, ShowFor} from "@brightagency/headstart-common";
import React from "react";
import { WPPost } from "../../../constants/types";
import { ListingAcf } from "../../../constants/types/acf";
import { useSuburbName} from "../../../utils";
import { CarouselControls } from "../../molecules/CarouselControls";
import { ListingCard } from "../../molecules/ListingCard";
import { SkeletonCard } from "../../molecules/SkeletonCard";
import { useCardCarousel } from "../Carousel";
import { Skeleton } from "../RelatedLocalServices/Skeleton";
import {
    Wrapper,
    Inner,
    Title,
    Content,
    TextContent,
    Controls,
} from "./styled";

interface Props {
    title: string;
    description: string | React.ReactChild;
    items: WPPost<ListingAcf>[];
    isLoading?: boolean;
}

export const RelatedListings: React.FC<Props> = props => {
    const { Carousel, scrollLeft, scrollRight, canScroll } = useCardCarousel(props.items.length);
    const suburbName = useSuburbName();

    return (
        <Wrapper>
            <Container>
                <Inner>
                    <TextContent>
                        <Title>{props.title} {suburbName}</Title>
                        <Content>{props.description}</Content>
                    </TextContent>
                    {canScroll && (
                        <ShowFor size={Size.large}>
                            <Controls>
                                <CarouselControls
                                    onLeftClick={scrollLeft}
                                    onRightClick={scrollRight}
                                />
                            </Controls>
                        </ShowFor>
                    )}
                </Inner>
            </Container>
            <div className={props.items.length <= 0 && !props.isLoading ? 'listing-not-found' : ''}>
                <Carousel>
                    {props.isLoading && props.items.length === 0 ? 
                        Array(3)
                            .fill(1)
                            .map((el, index) => <SkeletonCard key={index} />)
                        : props.items.length > 0
                            ? props.items.map(listing => (
                            <ListingCard key={listing.id} listing={listing} compact={false} />
                            ))
                            : <Skeleton /> 
                    }
                </Carousel>
            </div>
        </Wrapper>
    );
};
